// extracted by mini-css-extract-plugin
export default {"container":"PhotoAbsence_container__ku5s+","img":"PhotoAbsence_img__3CFed"};